'use client';

import { cn } from '@/lib/utils';
import { Link as NavigationLink } from '@/i18n/navigation';

const linkVariants = {
  default:
    'text-h5 font-normal hover:text-brand transition-all ease-in-out duration-300 ease text-dark-grey group',
  contact:
    'text-h5 font-normal hover:text-white hover:underline transition-all ease-in-out duration-300 ease group',
};

const Link = ({
  title,
  href,
  className,
  ariaLabel,
  target,
  children,
  onClick = () => {},
  variant = 'default',
}: {
  href: string;
  title?: string;
  className?: string;
  ariaLabel?: string;
  target?: string;
  children?: React.ReactElement;
  onClick?: () => void;
  variant?: keyof typeof linkVariants;
}) => {
  const linkStyles = cn(linkVariants[variant], className);

  return (
    <NavigationLink className={linkStyles} href={href} target={target} onClick={onClick} aria-label={ariaLabel}>
      {children ? (
        children
      ) : variant === 'contact' ? (
        title
      ) : (
        <span className="bg-left-bottom bg-gradient-to-r from-brand to-brand bg-[length:0%_2px] bg-no-repeat group-hover:bg-[length:100%_2px] transition-all duration-500 ease-out">{title}</span>
      )}
    </NavigationLink>
  );
};

export default Link;
